/* eslint-disable */
export default {
    bind(el, binding, vnode) {

        vnode.context.$root.$on( 'bv::modal::shown', (evt) => {

            setTimeout(function() {
                var searchBoxes = document.querySelectorAll('.CoveoSearchInterface');
                // Iterate over each item and attach a click event listener
                searchBoxes.forEach(function(searchBox, index) {
                        let searchButton = 'CoveoSearchButton'
                        //console.log(searchBox, index)
                        let selectedSearchButton = document.querySelector(`#${searchBox.id} .${searchButton}`)
                        //selectedSearchButton.addEventListener('click', function() {
                            //console.log('selectedSearchButton', selectedSearchButton)
                            //console.log('searchBox', searchBox)
                            if(searchBox && window.Coveo && typeof window.Coveo !== 'undefined'){
                                //console.log('window.Coveo', window.Coveo, typeof window.Coveo)
                                window.Coveo.$$(searchBox).on('newQuery', function(e){
                                    vnode.context.$root.$emit('bv::hide::modal', 'coveomodal1');
                                    vnode.context.$root.$emit('bv::hide::modal', 'coveomobilemodal');
                                });
                            };
                        //})
                    });
            }, 0);

            // get opend modal
            const modal = el.querySelector('.modal.fade.show');
            
            if (modal) {
                // add all the elements inside modal which you want to make focusable
                const  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                // get first element to be focused inside modal
                const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];

                firstFocusableElement.focus();

                const focusableContent = modal.querySelectorAll(focusableElements);

                // get last element to be focused inside modal
                const lastFocusableElement = focusableContent[focusableContent.length - 1];

                document.addEventListener('keydown', function(e) {
                    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            
                    if (!isTabPressed) { return; }
            
                    // if shift key pressed for shift + tab combination
                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        if (document.activeElement === lastFocusableElement) {
                            // add focus for the first focusable element
                            firstFocusableElement.focus();
                            e.preventDefault();
                        }
                    }
                });
            }
        });
    }    
}


// WEBPACK FOOTER //
// ./src/app/directives/close-coveo-modal.js